<template>
  <div
    v-if="garageData"
    class="garage-services-page__layout"
  >
    <div class="garage-services-page">
      <div class="show-on-mobile">
        <GaragePriceListHeader
          :garage="garageData.garage"
          :total-comments="totalCommentsComputed"
          :garage-image="garageData.garageImages"
        />
      </div>

      <div class="garage-services-page__header-wrapper">
        <div class="hide-on-mobile">
          <div class="d-flex">
            <NuxtLink
              class="garage-services-page__header"
              :to="`/mechanicy/${garageData?.garage.citySlug}/${garageData?.garage.nameSlug}.html`"
            >
              <NuxtImg
                src="/_nuxt/chevronBack.svg"
                height="24px"
                alt="Szczegóły wizyty"
                width="24px"
              />
            </NuxtLink>
            <div class="garage-services-page__header ml-3">
              <h3>{{ garageData.garage.premium ? "Wybierz rodzaj wizyty" : "Usługi" }}</h3>
            </div>
          </div>
        </div>
      </div>

      <div class="garage-services-page__container">
        <div class="garage-services-page__wrapper">
          <div>

            <template v-if="form.fields.serviceType.key === EGarageServiceType.Service">
              <div class="garage-services-page__search-bar">
                <div class="garage-services-page__search-bar-wrapper">
                  <DmRadioButton
                    v-if="!!garageData.garageOtherServiceAvailability?.available && !!garageData.garage.premium && !!garageData.garage.onlineBooking"
                    id="serviceTypeRadioButton"
                    v-model="form.fields.serviceType"
                    :items="serviceTypes"
                    class="garage-services-page__tabs"
                  />
                  <div class="garage-services-page__search-input-wrapper">
                    <div class="garage-services-page__filters">
                      <div
                        @click="modals.search = true"
                        class="garage-services-page__filters-search"
                      >
                        <i class="i-search" />
                      </div>
                      <div class="garage-services-page__filters-divider"></div>

                      <div class="garage-services-page__carousel-wrapper">
                        <div
                          class="garage-services-page__filters-carousel"
                          id="garage-service-page.filters-carousel"
                        >
                          <div
                            @click="onFilterSelect(popularCategoryId)"
                            class="garage-services-page__filter"
                            :class="{ 'garage-services-page__filter--selected': form.fields.categoryFilter === popularCategoryId }"
                          >
                            Wszystkie
                          </div>
                          <div
                            v-for="(category, index) in categoryFilters"
                            :key="category.key"
                            v-show="index < 5"
                            @click="onFilterSelect(category.key)"
                            class="garage-services-page__filter"
                            :class="{ 'garage-services-page__filter--selected': form.fields.categoryFilter === category.key }"
                          >
                            {{ capitalizeFirstLetter(category.text) }}
                          </div>
                          <div
                            @click="modals.search = true"
                            class="garage-services-page__filter"
                          >
                            Pozostałe
                            <i class="i-arrow-right" />
                          </div>
                        </div>
                        <div
                          v-show="categoryFilters.length > 3"
                          class="garage-services-page__filter-buttons"
                        >
                          <button
                            @click="desktopScroll(-500)"
                            class="garage-services-page__filter-button"
                          ><i class="i-arrow-left" /></button>
                          <button
                            @click="desktopScroll(500)"
                            class="garage-services-page__filter-button"
                          ><i class="i-arrow-right" /></button>
                        </div>
                      </div>
                    </div>
                    <Transition>
                      <div
                        v-show="searchInputFocus"
                        class="garage-services-page__search-bar-button"
                        role="button"
                        @click="searchInputFocus = false"
                      >Anuluj</div>
                    </Transition>
                  </div>
                </div>
              </div>
              <GaragePriceListWithCategories
                v-if="garageData.garagePriceListWithCategories"
                :garage-price-list-with-categories="garageData.garagePriceListWithCategories"
                :currentFilter="form.fields.categoryFilter"
                :premium="!!garageData.garage?.premium"
                :onlineBooking="!!garageData.garage?.onlineBooking"
                @set-other-reason-tab="setOtherReasonTab()"
                @show-service-details="showServiceDetails($event)"
              />
            </template>

            <template v-else-if="!!garageData?.garage?.onlineBooking">
              <DmRadioButton
                v-if="!!garageData.garageOtherServiceAvailability?.available"
                id="serviceTypeRadioButton"
                v-model="form.fields.serviceType"
                :items="serviceTypes"
                class="garage-services-page__tabs"
              />
              <form
                id="repair-reason.form"
                class="garage-services-page__form"
                @submit.prevent
              >

                <h4 class="repair-reason-header">Co wymaga naprawy?</h4>
                <div class="repair-reason-radios">
                  <div
                    v-for="(item, index) in computedRepairCategories"
                    :key="`${item.id}`"
                    @click="selectRepairCategory(item.id)"
                    @keyup.enter="selectRepairCategory(item.id)"
                    class="repair-reason-radio"
                  >
                    <input
                      :id="`${item.id}`"
                      class="repair-reason-radio__input"
                      type="radio"
                      name="repair-reason-service"
                      tabindex="-1"
                      :checked="form.fields.serviceId === item.id"
                    >
                    <div
                      :tabindex="form.fields.serviceId === item.id ? -1 : 0"
                      class="repair-reason-radio__checkmark"
                      :class="{ 'repair-reason-radio__checkmark--checked': form.fields.serviceId === item.id }"
                    />
                    <label
                      class="repair-reason-radio__text"
                      :for="`${item.id}`"
                    >
                      <NuxtImg
                        :src="`/_nuxt/repair-categories/${item.id}.svg`"
                        width="30px"
                        height="30px"
                      />
                      <div>
                        {{ item.categoryName }}
                        <div
                          class="repair-reason-radio__description"
                          v-if="item.id === otherRepairsId"
                        >Kliknij tutaj, opisz problem i umów wizytę.</div>
                      </div>
                    </label>
                  </div>
                </div>
              </form>
            </template>
          </div>
        </div>
        <div
          v-if="garageData"
          class="garage-services-page__sidebar"
        >
          <GaragePriceListHeader
            :garage="garageData.garage"
            :total-comments="totalCommentsComputed"
            :garage-image="garageData.garageImages"
          />
        </div>
      </div>
    </div>
  </div>
  <DmLoader
    v-if="!!pending"
    icon-size="icon-lg"
  />

  <ClientOnly>
    <DmModal
      :modelValue="modals.service"
      @update:modelValue="onCloseRepairModal"
      title="Dodatkowy opis (opcjonalnie)"
    >
      <div>
        <div class="garage-services-page__badge mb-4">
          <i class="i-info" />
          <p class="garage-services-page__badge-paragraph">Dodatkowe informacje przyspieszą diagnostykę usterki i
            naprawę.</p>
        </div>

        <DmTextarea
          id="repair-reason.textarea"
          class="repair-reason-textarea"
          label="Opisz krótko problem z samochodem"
          placeholder="np. Podczas jazdy stuka coś w zawieszeniu"
          v-model="form.fields.repairReason"
          :required="true"
          pattern="\S{3,}"
          @update:errors="updateErrors($event, 'repair-reason')"
        />

        <div class="garage-services-page__helpers">
          <div
            v-for="reason in repairReasons"
            class="garage-services-page__helper"
            :class="{ 'garage-services-page__helper--selected': isHelperSelected(reason) }"
            @click="addReason(reason)"
          >
            {{ reason }}
          </div>
        </div>
      </div>
      <DmButton
        @click.prevent="submit"
        title="Wybierz termin"
        class="w-100 mb-4 mt-5"
        @click="modals.service = true"
      />
    </DmModal>
  </ClientOnly>
  <GaragePriceCategorySearchModal
    :modals="modals"
    :premium="!!garageData?.garage.premium"
    :onlineBooking="!!garageData?.garage?.onlineBooking"
    :garageId="`${garageData?.garage.id}`"
    @show-service-details="showServiceDetails($event)"
    @set-other-tab="setOtherReasonTab"
    @close-search-modal="modals.search = false"
  />
  <GaragePriceCategoryElementModal
    :premium="garageData?.garage.premium"
    :onlineBooking="!!garageData?.garage?.onlineBooking"
    :modals="modals"
    :service="selectedServiceForDetails"
  />
</template>

<script setup lang="ts">
import { useFormCreator } from '@/composables/useFormCreator';
import DmRadioButton from '@/components/UIComponents/DmRadioButton.vue';
import { DmLoader, DmTextarea, DmButton, DmModal } from '@dobrymechanik/vue-ui-v2';
import type { IDmComponentsItem } from '~/models/components';
import { appRequests } from '~/api/app-instance';
import type { GarageAutobookingServiceStatus, GarageGooglePlaceReview, LegacyService, PriceCategoryView, PriceElementView, VirtualServiceCategory } from '~/api/docs/app';
import { useStore } from '~/store/store';
import { apiRequests } from '~/api/api-instance';
import type { GarageImageJsonldGarageImageRead, GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead } from '~/api/docs/api';
import GaragePriceCategorySearchModal from '@/components/GaragePriceCategorySearchModal.vue';
import { popularCategoryId } from '~/models/consts';
import { capitalizeFirstLetter } from '~/helpers/helpers';
import GaragePriceListHeader from '~/components/GaragePriceListHeader.vue';

definePageMeta({
  layout: "modal",
});

enum EGarageServiceType {
  Service,
  Issue
}

interface IGarageServicesFields {
  serviceType: IDmComponentsItem;
  search: string;
  repairReason: string;
  serviceId: string;
  categoryFilter: string;
}

useHead({
  meta: [
    { hid: 'robots', name: 'robots', content: 'noindex, nofollow' }
  ]
});


// reactives and consts
const searchInputFocus: Ref<boolean> = ref(false);
const reasonsArr: Ref<string[]> = ref([]);
const garageId = ref('');
const categoryFilters: Ref<any[]> = ref([]);
const modals = ref({
  service: false,
  search: false,
  details: false
});
const selectedServiceForDetails: Ref<PriceElementView | null> = ref(null);

// computed
const serviceTypes = computed(() => {
  return [
    {
      key: EGarageServiceType.Service, text: 'Usługa z cennika', metadata: { icon: 'i-history' }
    },
    {
      key: EGarageServiceType.Issue, text: 'Naprawa usterki', metadata: { icon: 'i-edit' }
    }
  ];
});

const totalCommentsComputed = computed(() => {
  return (garageData.value?.garage.commentsTotal || 0) + (garageData.value?.commentsFromGoogle.length || 0);
});

const garagePath = computed(() => {
  return route.params['garageId'] as string;
});

const repairReasons = computed(() => {
  return garageData.value?.garageVitualPriceList.find(el => el.id === form.value.fields.serviceId)?.pills;
});

const computedRepairCategories = computed(() => {
  const otherRepair = {
    categoryName: 'Nie wiesz co wybrać?',
    id: otherRepairsId,
    pills: [],
    priceName: '',
    requiredSeoServiceSlug: '',
    requiredSeoServiceSlugId: 0
  };

  return [...garageData.value?.garageVitualPriceList || [], otherRepair];
});

const setCategoryFilters = () => {
  if (!garageData.value) return;
  categoryFilters.value = garageData.value.garagePriceListWithCategories.map(category => {
    return {
      text: category.shortName,
      key: category.id
    };
  });
};

// use
const router = useRouter();
const route = useRoute();
const { form, valid, updateErrors, checkFormValidity } = useFormCreator<IGarageServicesFields>({
  serviceType: serviceTypes.value[0],
  search: '',
  repairReason: '',
  serviceId: '',
  categoryFilter: popularCategoryId
});
const store = useStore();
const { $posthog } = useNuxtApp();
const nuxtApp = useNuxtApp();

const otherRepairsId: string = '9f1331f2-66c0-4341-ad06-cc6f074e1857';


interface IGarageDataForServices {
  garage: GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead;
  garagePriceListWithCategories: PriceCategoryView[];
  garageOtherServiceAvailability: GarageAutobookingServiceStatus;
  garageVitualPriceList: VirtualServiceCategory[];
  commentsFromGoogle: GarageGooglePlaceReview[];
  garageImages: GarageImageJsonldGarageImageRead[];
}

// watch 
watch(() => route.query, (queries, queriesFrom) => {
  if (form.value.fields.serviceType.key === EGarageServiceType.Service && queries?.["other-reason"]) {
    setOtherReasonTab();
  } else if (!queries?.["other-reason"] && queriesFrom?.["other-reason"]) {
    setPriceListTab();
  }
});

watch(() => form.value.fields.serviceType, (serviceType) => {
  if (serviceType.key === EGarageServiceType.Issue) {
    if (route.query['service-id']) {
      selectRepairCategory(route.query['service-id'] as string);
    }
    router.replace({ query: { "other-reason": "true" } });
  } else {
    router.replace({ query: {} });
  }

});

// methods
const { data: garageData, pending, error, refresh } = await useAsyncData(
  "garageDataForServices",
  async () => {

    if (!form.value.fields.categoryFilter) {
      const cachedGarageData = useNuxtApp().payload.data.garageData;
      if (!!cachedGarageData) return cachedGarageData as IGarageDataForServices;
    }

    const { data: { id } } = await appRequests.getAppGarageIdByUrl(garagePath.value);
    const idString = id?.toString();
    garageId.value = idString || '';

    if (!idString) return;
    const GETgarage = apiRequests.apiGarageIdGet(idString);
    const GETgaragePriceListWithCategoriesForAb = appRequests.getAppGaragePriceListWithCategories(idString, {
      categoryId: form.value.fields.categoryFilter === popularCategoryId ? null : form.value.fields.categoryFilter,
      seoServiceId: route.query['service-context'] || null
    });
    const GETotherServiceAvailability = appRequests.getAppGarageAutobookingServiceAvailability(idString, otherRepairsId);
    const GEThelpers = appRequests.getAppGarageVirtualServiceCategoriesList(idString);
    const GETcommentFromGoogle = appRequests.getAppGarageGooglePlaceReview(idString);
    const GETgarageImageCollection = apiRequests.apiGarageGarageIdimagesGetCollection(idString, {
      'type[]': ['building-exterior-and-surroundings', 'example-cars', 'working-mechanics', 'workshop-hall']
    });

    const [garage, garagePriceListWithCategories, garageOtherServiceAvailability, garageVitualPriceList, commentsFromGoogle, garageImages] =
      await Promise.all([
        (await GETgarage).data,
        (await GETgaragePriceListWithCategoriesForAb).data,
        (await GETotherServiceAvailability).data,
        (await GEThelpers).data,
        (await GETcommentFromGoogle).data,
        (await GETgarageImageCollection).data['hydra:member']
      ]);

    return {
      garage, garagePriceListWithCategories, garageOtherServiceAvailability, garageVitualPriceList, commentsFromGoogle, garageImages
    };
  }, {
  lazy: true
});

if (!garageData.value && !nuxtApp.payload.data && !nuxtApp.payload.data) {
  throw createError({ statusCode: 404, message: 'Strona nie została odnaleziona', fatal: true });
}

const addReason = (reason: string) => {
  const include = reasonsArr.value.includes(reason);

  if (include) {
    reasonsArr.value = reasonsArr.value.filter(el => el !== reason);
  } else {
    reasonsArr.value.push(reason);
  }

  let reasonStr: string = '';

  reasonsArr.value.forEach((reason, index) => {
    if (index === 0) {
      reasonStr = reasonStr + reason;
    } else {
      reasonStr = reasonStr + '; ' + reason;
    }
  });

  form.value.fields.repairReason = reasonStr.trim();

  const textArea = document.getElementById('repair-reason.textarea');
  textArea?.focus();
  setTimeout(() => textArea?.blur(), 0);
};

const submit = async () => {
  const isFormValid = await checkFormValidity('repair-reason.form');

  if (isFormValid) {
    let subname: string = garageData.value?.garageVitualPriceList.find(category => {
      return category.id === form.value.fields.serviceId;
    })?.categoryName || 'Naprawa';

    const dsc = subname + (form.value.fields.repairReason ? `: ${form.value.fields.repairReason}` : '');
    router.push({ name: `mechanicy-city-garageId-services-serviceId`, params: { serviceId: otherRepairsId }, query: { repairDescription: dsc } });
  }
};

const setOtherReasonTab = () => {
  form.value.fields.serviceType = serviceTypes.value[1];
};

const setPriceListTab = () => {
  form.value.fields.serviceType = serviceTypes.value[0];
};

const isHelperSelected = (helper: string) => {
  const regExp = new RegExp(helper, 'gmi');
  return !!regExp.test(form.value.fields.repairReason);
};


const onFilterSelect = (key: string) => {

  if (form.value.fields.categoryFilter === key) {
    form.value.fields.categoryFilter = popularCategoryId;
  } else {
    form.value.fields.categoryFilter = key;
  }

  refresh();
};

const selectRepairCategory = (item?: string | null) => {
  if (!item) return;
  form.value.fields.serviceId = item;
  modals.value.service = true;
};

const onCloseRepairModal = () => {
  form.value.fields.repairReason = '';
  reasonsArr.value = [];
  modals.value.service = false;
};

const desktopScroll = (val: number) => {
  const scrollEl = document.getElementById('garage-service-page.filters-carousel');
  if (!scrollEl) return;
  scrollEl.scrollLeft += val;
};

const showServiceDetails = (service: PriceElementView | null) => {
  selectedServiceForDetails.value = service;
  modals.value.details = !!service;
};

const setRWGtoken = () => {
  const rwg_token = route.query['rwg_token'];
  const garageId = garageData.value?.garage.id;
  if (rwg_token && garageId) {
    document.cookie = "_rwgToken=" + rwg_token + "; max-age=2592000; path=/";
    document.cookie = "_merchantId=" + garageId + "; max-age=2592000; path=/";
  }
};

// watch
watch(() => garageData.value?.garagePriceListWithCategories, (val) => {
  if (val?.length && !categoryFilters.value.length) {
    setCategoryFilters();
  }
}, {
  immediate: true
});

onMounted(() => {
  setTimeout(() => {
    if (route.query['other-reason']) {
      setOtherReasonTab();
    }
    $posthog()?.capture('$pageview', {
      garageType: !!garageData.value?.garage.premium ? 'premium' : 'free',
      garageId: garageData.value?.garage.id || null
    });

    if (route.query['service-id']) {
      selectRepairCategory(route.query['service-id'] as string);
    }

    // RWG_TOKEN
    setRWGtoken();
  }, 0);
})


</script>

<style lang="scss">
@import url('assets/styles/pages/garage-services.scss');
</style>